module.exports = __webpack_public_path__ + "assets/img/3_1388.3bc2109a.jpg";